/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type LoginDialogUserQueryVariables = {
    username: string;
};
export type LoginDialogUserQueryResponse = {
    readonly user: {
        readonly id: string;
        readonly email: string | null;
    } | null;
};
export type LoginDialogUserQuery = {
    readonly response: LoginDialogUserQueryResponse;
    readonly variables: LoginDialogUserQueryVariables;
};



/*
query LoginDialogUserQuery(
  $username: String!
) {
  user(username: $username) {
    id
    email
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginDialogUserQuery",
    "selections": (v1/*: any*/),
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginDialogUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f58f73461feb2ecfe9b5153934d6eb60",
    "id": null,
    "metadata": {},
    "name": "LoginDialogUserQuery",
    "operationKind": "query",
    "text": "query LoginDialogUserQuery(\n  $username: String!\n) {\n  user(username: $username) {\n    id\n    email\n  }\n}\n"
  }
};
})();
(node as any).hash = '39089cbc486dd2e1a120e0e5b348cc7c';
export default node;
